/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];
// Place the currency symbol before the price.
const priceConfig = {
  CURRENCY_PLACEMENT: 'before',
  USE_SPACING: false,
};

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'PALM SPRINGS TRIBUNE JOBS',
    SITE_DESCRIPTION:
      'The Palm Springs Tribune is your source for Local News in Palm Springs and Coachella Valley. Brought to you by locals who know and love Palm Springs',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/PSTribune',
      twitter: 'https://twitter.com/PSTribuneNews',
      linkedin: 'https://www.linkedin.com/company/palm-springs-tribune/',
      instagram: 'https://www.instagram.com/pstribune',
    },
    ASSETS: {
      logo: '/static/pstribune/logo.png',
      faviconsPath: '/static/pstribune',
    },
    OG_IMAGE: '/static/pstribune/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#1151d3',
        secondary: '#0b368c',
      },
      logo: {
        minHeight: 90,
      },
    },
    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: false,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-WEWN6F7LZT', 'G-04SBN34ERZ'],
    PRICE_CONFIG: priceConfig,
    BLOG_FEATURE_ACTIVE: true,
  },
});
